import styled from 'styled-components';

export const SiteFooterSection = styled.div`
  background: ${props => props.theme.colors.b.dgr};

  > section {
    ${props => props.theme.layout.sectionInner}
  }

  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 24px 0;
    border-bottom: 1px solid ${props => props.theme.colors.b.lg};

    .colored {
      a {
        color: ${props => props.theme.colors.b.bk};
      }
    }
  }

  select {
    padding: 10px 10px;
    border: 1px solid ${props => props.theme.colors.b.lg};
    background: ${props => props.theme.colors.b.dgr};
    color: ${props => props.theme.colors.b.wh};
  }

  .info {
    padding: 32px 0;
    .logo {
      padding-bottom: 24px;
    }

    > section {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    p {
      font-size: 12px;
      color: ${props => props.theme.colors.b.wh};
      line-height: 1.7;
    }
  }

  .floating-banner {
    position: fixed;
    bottom: 300px;
    right: 50%;
    transform: translate(750px, 0);
  }

  .footer-social-banner {
    width: 30px;
    margin: 30px auto 0;

    a {
      font-size: 22px;
      display: inline-block;
      padding: 8px 0;
      i {
        color: #999;
      }
    } 
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    padding: 0 4%;

    .nav {
      flex-direction: column;
      align-items: start;

      select {
        margin: 12px 0 0 0;
      }
    }

    .info {
      > section {
        flex-direction: column;
        align-items: start;
      }
    }
  }
`;
